// Site-wide content — CMS-ready single source for editorial blocks.
export const whyUs = [
  { title: "Business-first sustainability", body: "We connect ESG with strategy, risk and value creation." },
  { title: "Evidence over assumptions", body: "We emphasise traceable data, documented methodologies and credible analysis." },
  { title: "India + global perspective", body: "We combine Indian regulatory context with international ESG frameworks." },
  { title: "Integrated expertise", body: "Environmental + Social + Governance + Climate + Sustainable Finance." },
  { title: "Practical recommendations", body: "Every assessment should lead to clear actions." },
  { title: "Long-term capability building", body: "We do not simply deliver reports. We help organisations build internal ESG capability." },
];

export const values = [
  { title: "Evidence", body: "Claims should be traceable to data and method." },
  { title: "Practicality", body: "Recommendations must be implementable in real organisations." },
  { title: "Business relevance", body: "Sustainability should improve the quality of decisions." },
  { title: "Integrity", body: "Honest analysis, including when the answer is uncomfortable." },
  { title: "Measurable outcomes", body: "What gets defined gets managed; what gets measured improves." },
];

export const processSteps = [
  { num: "01", title: "Discover", body: "Understand business, stakeholders and material issues." },
  { num: "02", title: "Assess", body: "Measure ESG performance, risk and opportunity." },
  { num: "03", title: "Design", body: "Build strategy, policies, governance and targets." },
  { num: "04", title: "Measure", body: "Develop ESG, carbon, climate and social metrics." },
  { num: "05", title: "Disclose", body: "Prepare credible reporting and investor disclosures." },
  { num: "06", title: "Improve", body: "Turn findings into practical action." },
];

export const pillars = [
  { id: "E", name: "Environmental", focus: ["GHG Accounting & Carbon Footprinting", "Climate Risk Assessment", "Net Zero & Decarbonisation", "Biodiversity Assessment", "Water & Resource Assessment", "Environmental Strategy"], service: "environment" },
  { id: "S", name: "Social", focus: ["Diversity & Inclusion Assessment", "Human Rights Assessment", "Social Impact Assessment", "ESG / Sustainability Training"], service: "social" },
  { id: "G", name: "Governance", focus: ["ESG Policy Development", "ESG Governance", "ESG Risk Assessment"], service: "governance" },
];

export const megaMenu = [
  { name: "Environmental", href: "/services#environment" },
  { name: "Social", href: "/services#social" },
  { name: "Governance", href: "/services#governance" },
  { name: "Reporting", href: "/services#reporting" },
  { name: "Climate", href: "/services/climate-risk" },
  { name: "Responsible Investment", href: "/services/responsible-investment" },
  { name: "Training", href: "/services/esg-training" },
];

export const controlRoomMetrics = [
  { label: "ESG Maturity", value: 72 },
  { label: "Carbon Data Readiness", value: 64 },
  { label: "Climate Readiness", value: 48 },
  { label: "Social Readiness", value: 81 },
  { label: "Governance Readiness", value: 76 },
  { label: "Disclosure Readiness", value: 68 },
];
